import { getDate } from '../../../utils/dateUtils';
import { numberToWords } from '../../../utils/helper';
export const generatePdfComponent = ({
	invoice_type,
	payment_method_section,
	gst_number,
	dl_number,
	user1,
	user2,
	invoice_detail,
	table_columns,
	table_body_data,
	taxCalculation,
	footer_table_columns,
	footer_table_data,
	notes,
	totalGrand,
	isLastChunk,
}) => {
	const headerRow = table_columns.map((col) => ({
		text: col.label,
		fontSize: 6,
		fillColor: '#FFF',
		color: '#000',
		alignment: 'left',
	}));
	const dataRows = table_body_data.map((data) => {
		return table_columns.map((col) => {
			let value;

			if (col.type === 'number') {
				value = Number(data[col.key]).toFixed(2);
			} else if (col.type === 'date') {
				value = getDate(data[col.key]);
			} else {
				value = data[col.key];
			}

			return {
				text: value ?? '',
				fontSize: 6,
				color: '#000',
				fillColor: '#FFFFFF',
			};
		});
	});

	const minRows = invoice_type === 'SALES RETURN' ? 4 : 8;
	const currentRows = dataRows.length;
	const emptyRowsNeeded = Math.max(0, minRows - currentRows);

	const emptyRows = Array(emptyRowsNeeded)
		.fill()
		.map(() =>
			table_columns.map(() => ({
				text: '',
				fontSize: 6,
				color: '#000',
				fillColor: '#FFFFFF',
			})),
		);

	const tableBody = [headerRow, ...dataRows, ...emptyRows];
	const data = {
		pageMargins: [0, 0, 0, 0],
		content: [
			{
				width: '100%',
				table: {
					widths: ['22%', '56%', '22%'],
					body: [
						[
							{
								stack: [
									{ text: `GSTIN: ${gst_number}`, fontSize: 6 },
									{ text: `D.L.No. ${dl_number}`, fontSize: 6, margin: [0, 2, 0, 0] },
								],
								heights: 40,
								alignment: 'left',
								valign: 'bottom',
								margin: [0, 10, 0, 0],
							},
							{
								stack: [
									{ text: invoice_type, fontSize: 6 },
									{ text: user1.name, bold: true, fontSize: 6 },
									{ text: `${user1.address}, ${user1.city}, ${user1.state}`, fontSize: 6 },
									{ text: user1.zip_code, fontSize: 6 },
								],

								alignment: 'center',
								valign: 'bottom',
							},
							{
								stack: [
									{ text: `Phn: ${user1.phone || 'N/A'}`, fontSize: 6 },
									{
										text: `Mobile No: ${user1.mobile || 'N/A'}`,
										fontSize: 6,
										margin: [0, 2, 0, 0],
									},
								],
								heights: 40,
								alignment: 'right',
								valign: 'bottom',
								margin: [0, 10, 0, 0],
							},
						],
					],
				},
				layout: {
					hLineWidth: function (i, node) {
						return 1;
					},
					vLineWidth: function (i, node) {
						return i === 1 || i === 2 ? 0 : 1;
					},
					fillColor: function () {
						return '#FFF';
					},
					hLineColor: function () {
						return '#000';
					},
					vLineColor: function () {
						return '#000';
					},
				},
			},
			{
				table: {
					widths: ['50%', '20%', '30%'],
					body: [
						[
							{
								stack: [
									{
										text: `${user2.name}`,
										color: '#000',
										bold: true,
										fontSize: 6,
										alignment: 'left',
										margin: [0, 0, 0, 2],
									},
									{
										text: `${user2.address}, ${user2.city}, ${user2.state}`,
										color: '#000',
										fontSize: 6,
										alignment: 'left',
										margin: [0, 0, 0, 2],
									},
									{
										text: `${user2.zip_code}`,
										color: '#000',
										fontSize: 6,
										alignment: 'left',
										margin: [0, 0, 0, 2],
									},
									user2.phone && {
										text: `Phn: ${user2.phone}`,
										color: '#000',
										fontSize: 6,
										alignment: 'left',
										margin: [0, 0, 0, 2],
									},
									user2.email && {
										text: `${user2.email}`,
										color: '#000',
										fontSize: 6,
										alignment: 'left',
										margin: [0, 0, 0, 2],
									},
								].filter(Boolean),
								alignment: 'left',
								valign: 'bottom',
								margin: [0, 0, 0, 0],
							},
							{
								stack: payment_method_section.map((data) => ({
									text: data.value,
									bold: data.bold,
									color: '#000',
									fontSize: 6,
									alignment: 'center',
									margin: [0, 2, 0, 0],
								})),
								alignment: 'center',
								valign: 'top',
							},
							{
								stack: invoice_detail.map((invoice) => ({
									text: invoice.value,
									bold: invoice.bold,
									color: '#000',
									fontSize: 6,
									alignment: 'right',
									margin: [0, 0, 0, 2],
								})),
								alignment: 'right',
								valign: 'bottom',
								margin: [0, 0, 0, 0],
							},
						],
					],
				},
				layout: {
					hLineWidth: function (i, node) {
						return 0;
					},
					vLineWidth: function (i, node) {
						return 1;
					},
					fillColor: function () {
						return '#FFF';
					},
					hLineColor: function () {
						return '#000';
					},
					vLineColor: function () {
						return '#000';
					},
				},
			},
			{
				table: {
					widths: table_columns.map((data) => data.tableColWidth),
					heights: Array(tableBody.length).fill(invoice_type === 'SALES RETURN' ? 15 : 5),
					body: tableBody,
				},
				layout: {
					hLineWidth: function (i, node) {
						return i === 0 || i === 1 || i === node.table.body.length ? 1 : 0;
					},
					vLineWidth: function (i, node) {
						return 1;
					},
					hLineColor: function (i, node) {
						return '#000';
					},
					vLineColor: function (i, node) {
						return '#000';
					},
					paddingTop: function (i, node) {
						return 2;
					},
					paddingBottom: function (i, node) {
						return 2;
					},
				},
			},

			invoice_type === 'SALES INVOICE' && {
				table: {
					widths: ['6%', '30%', '8%', '38%', '8%', '10%'],
					body: [
						[
							{
								text: '',
								color: '#000',
								fontSize: 6,
								alignment: 'left',
							},
							{
								text: 'Total',
								color: '#000',
								fontSize: 6,
								alignment: 'left',
							},
							{
								text: Number(
									table_body_data.reduce((sum, item) => Number(sum) + Number(item.qty), 0),
								).toFixed(2),
								color: '#000',
								fontSize: 6,
								alignment: 'left',
							},
							{
								text: '',
								color: '#000',
								fontSize: 6,
								alignment: 'left',
							},
							{
								text: '',
								color: '#000',
								fontSize: 6,
								alignment: 'left',
							},
							{
								text: Number(
									table_body_data.reduce((sum, item) => Number(sum) + Number(item.total_amount), 0),
								).toFixed(2),
								color: '#000',
								fontSize: 6,
								alignment: 'left',
							},
						],
					],
				},
				layout: {
					hLineWidth: function (i, node) {
						return i === node.table.body.length ? 1 : 0;
					},
					vLineWidth: function (i, node) {
						return 1;
					},
					hLineColor: function (i, node) {
						return '#000';
					},
					vLineColor: function (i, node) {
						return '#000';
					},
					paddingTop: function (i, node) {
						return 3;
					},
					paddingBottom: function (i, node) {
						return 3;
					},
				},
			},
			taxCalculation != null && {
				table: {
					widths: ['100%'],
					body: [
						[
							{
								stack: [
									{
										text: taxCalculation
											.map(
												(data) =>
													`CGST @${data.tax1}% - ${Number(data.taxAmount1).toFixed(2)}  SGST @${data.tax2}% - ${Number(data.taxAmount2).toFixed(2)}`,
											)
											.join(' | '),
										color: '#000',
										fontSize: 6,
										alignment: 'left',
										margin: [10, 0, 0, 0],
									},
								],
								border: [1, 1, 1, 1],
							},
						],
					],
				},
				layout: {
					hLineWidth: function (i, node) {
						return i === 0 ? 0 : 1;
					},
					vLineWidth: function (i, node) {
						return 1;
					},
					hLineColor: function (i, node) {
						return '#000';
					},
					vLineColor: function (i, node) {
						return '#000';
					},
					paddingTop: function (i, node) {
						return 3;
					},
					paddingBottom: function (i, node) {
						return 3;
					},
				},
			},
			footer_table_columns.length > 0 && {
				table: {
					widths: ['65%', '17%', '18%'],
					body: [
						[
							{
								stack: [
									{
										text: `Notes: ${notes || 'Thanks For Your Business.'}`,
										color: '#000',
										fontSize: 6,
										alignment: 'left',
										margin: [0, 0, 0, 0],
									},
								],
								border: [1, 0, 1, 0],
							},
							{
								stack: footer_table_columns.map((data) => ({
									text: data.value,
									color: '#000',
									bold: data.bold,
									fontSize: 6,
									alignment: 'left',
									margin: [0, 3, 0, 0],
								})),
								border: [0, 0, 0, 1],
							},
							{
								stack: footer_table_data.map((data, index) => ({
									text: `${data.value}`,
									color: '#000',
									bold: data.bold,
									fontSize: 6,
									alignment: 'right',
									margin: [0, 3, 0, 0],
									border:
										footer_table_data.length - 1 === index && invoice_type === 'SALES INVOICE'
											? [0, 1, 1, 1]
											: [0, 0, 1, 1],
								})),
								border: [0, 0, 1, 1],
							},
						],
					],
				},
				layout: {
					hLineColor: function (i, node) {
						return '#000';
					},
					vLineColor: function (i, node) {
						return '#000';
					},
					paddingTop: function (i, node) {
						return 2;
					},
					paddingBottom: function (i, node) {
						return 2;
					},
				},
			},
			{
				table: {
					widths: isLastChunk ? ['30%', '*', '*'] : ['100%'],
					body: [
						isLastChunk
							? [
									{
										stack: [
											footer_table_data.length < 1
												? {
														text: `Notes: ${notes || 'Thanks For Your Business.'}`,
														color: '#000',
														fontSize: 6,
														alignment: 'left',
														margin: [0, 0, 0, 0],
													}
												: {},
											{
												text: `Authorized Signature ............`,
												color: '#000',
												fontSize: 6,
												alignment: 'left',
												valign: 'bottom',
												margin: [
													0,
													footer_table_columns.length > 4
														? 0
														: footer_table_columns.length === 2
															? 25
															: 30,
													0,
													0,
												],
											},
										],
									},
									{
										stack: [
											totalGrand != null
												? {
														text: `Amount Recieved In Words:`,
														color: '#000',
														fontSize: 6,
														alignment: 'right',
														margin: [
															0,
															0,
															0,
															footer_table_columns.length > 4
																? 0
																: footer_table_columns.length === 2
																	? 25
																	: 30,
														],
													}
												: {},
										],
									},
									{
										stack: [
											totalGrand != null
												? {
														text: `${numberToWords(totalGrand)}`,
														color: '#000',
														fontSize: 6,
														bold: true,
														alignment: 'left',
														margin: [0, 0, 0, 0],
													}
												: {},
										],
									},
								]
							: [
									{
										stack: [
											{
												text: `Continue....`,
												color: '#000',
												fontSize: 6,
												alignment: 'right',
												margin: [0, 10, 10, 0],
											},
										],
									},
								],
					],
				},
				layout: {
					hLineWidth: function (i, node) {
						return i === node.table.body.length ? 1 : 0;
					},
					vLineWidth: function (i, node) {
						if (isLastChunk) {
							return i === 1 || i === 2 ? 0 : 1;
						} else {
							return 1;
						}
					},
					hLineColor: function (i, node) {
						return '#000';
					},
					vLineColor: function (i, node) {
						return '#000';
					},
					paddingTop: function (i, node) {
						return 2;
					},
					paddingBottom: function (i, node) {
						return 2;
					},
				},
				margin: [0, 0, 0, 10],
			},
		].filter((item) => item !== false),
		header: function () {
			return null;
		},
		footer: function () {
			return null;
		},
	};

	return data;
};
